export const PROPERTY_MEDIA_BUCKET = 'strashin-developments-media';
export const PROPERTY_MEDIA_MAX_FILES = 10;
// Supabase standard upload cap for non-resumable uploads.
export const PROPERTY_MEDIA_MAX_BYTES = 5 * 1024 * 1024 * 1024; // 5GB per file
export const PROPERTY_MEDIA_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
];
export const PROPERTY_MEDIA_ALLOWED_TYPES = PROPERTY_MEDIA_IMAGE_TYPES;
export const PROPERTY_HERO_MEDIA_ALLOWED_TYPES = [...PROPERTY_MEDIA_IMAGE_TYPES, 'video/mp4'];

export const PROPERTY_MEDIA_PUBLIC_BASE_PATH = 'properties';
